// extracted by mini-css-extract-plugin
export default {"columnOrientation":"columnOrientation-tqJOt","rowOrientation":"rowOrientation-Ihihk","checkboxesContainer":"checkboxesContainer-EyHeI","checkbox":"checkbox-zkyJY"};